import { useState, useEffect } from "react";
import Feature from "../feature-flag/Feature";
import { Collapse, ListGroupItem } from "reactstrap";
import RawNetworkPanelPageNav from "./RawNetworkPanelPageNav";
interface RawNetworkPanelProps {
  json: string;
}
const RawNetworkPanel = ({ json }: RawNetworkPanelProps) => {
  const [isOpen, setIsOpen] = useState(true);
  const [highlight, setHighlight] = useState(false);
  const [data, setData] = useState<any[]>([]);
  const [activeTab, setActiveTab] = useState(0);
  useEffect(() => {
    let parsedJSON: any[] = [];
    try {
      const result = JSON.parse(json);
      if (Array.isArray(result)) parsedJSON = result;
    } catch (e) {
      console.error("Error parsing JSON:", e);
    }
    setData(parsedJSON);
    setHighlight(true);
    setActiveTab(0);
    const timeout = setTimeout(() => {
      return setHighlight(false);
    }, 300);
    return () => clearTimeout(timeout);
  }, [json]);
  return (
    <Feature flag="LayerRawNetworkEnabled">
      <div className="bg-dark text-white opacity-90">
        <ListGroupItem
          className="d-flex justify-content-between align-items-center bg-dark p-2 cursor-pointer opacity-80"
          onClick={() => {
            setIsOpen(!isOpen);
          }}
        >
          <i className={`icon-select-results fa-lg`}></i>
          <span
            id="layerRawNetworkCollapseIcon"
            className={`icon-chevron-${isOpen ? "down" : "right"}`}
          ></span>
        </ListGroupItem>
      </div>
      <Collapse isOpen={isOpen}>
        <div className={`bg-dark text-white opacity-80 ${data && data.length > 0 ? "p-3" : "p-0"}`}>
          {data && data.length > 0 && (
            <div>
              {data.length > 1 && (
                <RawNetworkPanelPageNav
                  totalPageCount={data.length}
                  maxButtonsVisible={5}
                  activeTab={activeTab}
                  setActiveTab={setActiveTab}
                />
              )}
              <div>
                {Array.isArray(data[activeTab]) &&
                  data[activeTab].length > 0 &&
                  data[activeTab].map((item: any) => (
                    <ul className="list-unstyled mb-1" key={item.id}>
                      {Object.entries(item).map(([key, value]) => (
                        <li
                          key={key}
                          className={`mb-1 white-space-nowrap ${highlight ? "opacity-70" : "opacity-100"}`}
                        >
                          <strong>{key}: </strong>
                          <span className="ml-1 text-grey">{String(value)}</span>
                        </li>
                      ))}
                    </ul>
                  ))}
              </div>
            </div>
          )}
        </div>
      </Collapse>
    </Feature>
  );
};
export default RawNetworkPanel;
